import { Injectable } from "@angular/core";
import {Observable, of, switchMap, tap} from "rxjs";
import {MfsAllowLists} from "@mfs/default-dashboard/models/mfs-allow-lists.model";
import {MfsAllowListHttpDataService} from "@mfs/default-dashboard/services/mfs-allow-list-http-data.service";
import {UserSettings, UserSettingsService} from "@feature/user-settings";

@Injectable({ providedIn: 'root' })
export class MfsAllowListDataService {

  mfsAllowLists: MfsAllowLists;

  constructor(
    private readonly httpService: MfsAllowListHttpDataService,
    private readonly userSettings: UserSettingsService
  ) { }

  public getForCurrentUser(): Observable<MfsAllowLists> {
    return this.userSettings.getUserSettings().pipe(
      switchMap((userSettings: UserSettings) => {
        // re-query every time if we're in preview mode
        // otherwise previous allow lists for a different entity are potentially returned
        // causing the invalid entity page
        if (this.mfsAllowLists === undefined || userSettings.IsInPreviewMode) {
          return this.httpService.getForCurrentUser().pipe(
            tap((data: MfsAllowLists) => {
              this.mfsAllowLists = data;
            })
          );
        } else {
          return of(this.mfsAllowLists);
        }
      }));
  }
}
